import React from 'react'
import PropTypes from 'prop-types'
import { PreConsentLogo } from '../../utilities/icons'
import cdrIcon from '../../asset/CDRIcon.svg'
import {
  FooterContainer,
  Header,
  HeaderTitle,
  LinkBody,
  Link,
  FooterContent,
  FooterCard,
  CardIcon,
  CardContent,
  FooterBottom,
} from './style'

const PreconsentFooter = () => {
  const title = 'CompareBanks'
  const cardContent = (
    <p>
      Accreditation ID: ADRBNK00000XY <br></br> Learn more at{' '}
      <a
        href="https://www.cdr.gov.au/"
        target="_blank"
        rel="noreferrer"
        title="CDR offical site"
        aria-label="CDR offical site"
      >
        cdr.gov.au{' '}
      </a>
    </p>
  )

  return (
    <FooterContainer>
      <Header>
        <PreConsentLogo size="40" />
        <HeaderTitle>{title}</HeaderTitle>
      </Header>
      <LinkBody>
        {/* <Link href="/">About</Link>
        <Link href="/">Contact us</Link>
        <Link href="/">Our CDR Policy</Link>
        <Link href="/">Terms of use</Link> */}
      </LinkBody>
      <FooterContent>
        <FooterCard>
          <CardIcon src={cdrIcon} alt=""></CardIcon>
          <CardContent>{cardContent}</CardContent>
        </FooterCard>
        <FooterBottom>© 2022 CompareBanks Pty Ltd</FooterBottom>
      </FooterContent>
    </FooterContainer>
  )
}

PreconsentFooter.propTypes = {
  title: PropTypes.string,
  cardContent: PropTypes.node,
}

export default PreconsentFooter
